import React from 'react';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const sizeClasses = {
    small: 'h-4 w-4',
    medium: 'h-8 w-8',
    large: 'h-12 w-12'
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[200px]">
      <div className={`animate-spin rounded-full border-2 border-gray-600 border-t-primary-500 ${sizeClasses[size]}`}></div>
      {text && <p className="mt-2 text-gray-400 text-sm">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;